// @ts-ignore
import parse from "autosuggest-highlight/parse";

function match(value: string, search: string): number[][] {
  const tempParts: number[][] = [];
  search
    .toLowerCase()
    .split(" ")
    .filter((s) => !!s)
    .forEach((searchPart) => {
      const start = value.toLowerCase().indexOf(searchPart);
      if (start >= 0) {
        tempParts.push([start, start + searchPart.length]);
      }
    });
  const parts: number[][] = [];
  let lastStartIndex = -1;
  let lastEndIndex = -1;
  tempParts
    .sort((a, b) => a[0] - b[0])
    .forEach((tempPart) => {
      const [startIndex, endIndex] = tempPart;
      if (startIndex > lastEndIndex) {
        if (lastStartIndex > -1) {
          parts.push([lastStartIndex, lastEndIndex]);
        }
        lastStartIndex = startIndex;
        lastEndIndex = endIndex;
      } else if (endIndex > lastEndIndex) {
        lastEndIndex = endIndex;
      }
    });
  if (lastStartIndex > -1) {
    parts.push([lastStartIndex, lastEndIndex]);
  }
  return parts;
}
export { parse, match };
